$(document).ready(function () {
    $('.js-coming-next-animation').on("animationend", AnimationListener);

    function AnimationListener() {
        $('.js-coming-next-animation').off('animationend', AnimationListener);
        window.location.href = $('.js-next-episode').attr('href');
    }

    $('.js-cancel-animation').on('click', CancelAnimation);

    var seeMoreButton = $('.js-see-more');
    if(seeMoreButton.length) {
      var premium = seeMoreButton.attr('data-premium') === 'true';
    }

    var datachatIframe = $('.js-datachat-iframe');
    if(datachatIframe.length) {
      var baseUrl = datachatIframe.data('base-url');
    }

    window.addEventListener('message', function (message) {
        if (message.origin === baseUrl) {
            switch (message.data.type) {
                case 'END_PLAYBACK':
                    onEnd(message.data);
                    break;
                case 'UPDATE_TIME':
                    onTimeUpdate(message.data, premium, baseUrl);
                    break;
            }
        }
    });
});

function CancelAnimation() {
    // Hide animations
    $('.js-halfclip').hide();
    $('.js-halfcircle').hide();
}

function onTimeUpdate(data, premium, baseUrl) {
    var TRESHOLD = 30;   // treshold for 'see more' in seconds
    if (currentTime(data) > TRESHOLD && !premium) {
        pauseVideo(baseUrl);
        displaySeeMore();
    }
}

function onEnd(data) {
    $('.js-video-end').removeClass('hidden')
}

// Returns the current time of playback in seconds.
function currentTime(data) {
    return data.time * data.duration;   // data.time is the percentage of time passed of time.duration, time.duration the total time of the video in seconds
}

function pauseVideo(baseUrl) {
    window.frames['js-datachat-iframe'].postMessage({type: 'PAUSE_VIDEO'}, baseUrl)
}

function displaySeeMore() {
    $('.js-see-more').removeClass('hidden');
}
